<template lang="pug">
  modal(:title='$t("folders.createModal.title")' @closeModal='hideElement({ element: "folderCreateModal" })' :errorTitle='errorTitle')
    form(@submit.prevent='handleRename')
      .row.middle.message(v-if='error')
        simple-svg.icon.red-icon(:filepath='stopIcon' width='36px' height='36px')
        span.text-normal.description.width-100(v-if='error')
          | {{ $t('folders.createModal.errorDescription') }}
      .row.middle.content(v-else)
        .column.input-box.width-100
          label.text-normal.bold.name-label
            | {{ $t('folders.createModal.inputLabel') }}
          input.input-base.input-border(:placeholder='$t("folders.createModal.inputPlaceholder")' v-model.trim='$v.folderName.$model' :maxlength='folderNameMaxLength')
          span.text-small.m4-top-2.red(v-if='$v.folderName.$error')
            | {{ $t('folders.renameModal.errorEmptyName') }}
      .row.end
        button.secondary-button.m4-right-5(v-if='!error' type='button' @click='handleCancel()')
          | {{ $t('folders.createModal.cancel') }}
        button.primary-button.with-icon(v-if='!error')
          simple-svg.white-icon.m4-right-2(:filepath='createFolderIcon' :width='"20px"' :height='"20px"')
          | {{ $t('folders.createModal.save') }}
        button.primary-button(v-else type='button' @click='handleCancel()')
          | {{ $t('folders.createModal.ok') }}
</template>

<script>
import { mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'

import { createFolder } from '@/services/FolderService'
import { folderNameMaxLength } from '@/utils/constants'

import Modal from '@/components/Modal'
import stopIcon from '@/assets/ic_stop.svg'
import createFolderIcon from '@/assets/ic_new-folder.svg'

export default {
  props: {
    onFolderCreated: { type: Function }
  },
  data() {
    return {
      stopIcon,
      createFolderIcon,
      error: false,
      folderName: null,
      folderNameMaxLength
    }
  },
  methods: {
    ...mapActions(['hideElement', 'hydrateFolders']),
    handleRename() {
      if (this.$v.folderName.$invalid) {
        this.$v.folderName.$touch()
        return
      }
      createFolder(this.folderName).then(response => {
        if (response) {
          this.hideElement({ element: 'folderCreateModal' })
          if (this.onFolderCreated) this.onFolderCreated()
        } else {
          this.setErrorState()
        }
      }).catch(() => {
        this.setErrorState()
      })
    },
    handleCancel() {
      this.hideElement({ element: 'folderCreateModal' })
      this.$emit('cancel')
    },
    setErrorState() {
      this.error = true
    }
  },
  validations: {
    folderName: {
      required
    }
  },
  computed: {
    errorTitle() {
      return this.error ? this.$t('folders.createModal.errorTitle') : undefined
    }
  },
  components: { Modal }
}
</script>

<style lang="scss" scoped>
.content {
  max-width: 400px;
  margin: 23px 0 30px;
}

.message {
  margin: 50px 0;

  .icon {
    margin-right: 16px;
    height: 36px;
  }

  .description {
    max-width: 340px;
  }
}

.name-label {
  margin-bottom: 5px;
}

.input-box {
  min-height: 105px;
}
</style>
